<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <slot name="customHeader" />
          <h4 class="header-title mb-2">
            <span>LISTE DES TICKETS</span>
          </h4>
          <p class="text-muted font-14">
            Total de <span>{{ requests.length }}</span> tickets
          </p>

          <div
            v-if="requests.length"
            class="row"
          >
            <div class="col-md-12">
              <b-input-group>
                <b-form-input
                  v-model="filter"
                  placeholder="Recherche un enregistrement..."
                />
              </b-input-group>
            </div>
          </div>
          <br>

          <b-table
            stacked="md"
            :items="requests"
            :fields="fields"
            :filter="filter"
          >
            <template
              slot="id"
              slot-scope="request"
            >
              <router-link
                class="font-weight-bold"
                :to="{ path: `/service_tls/cases/${request.item.id}` }"
              >
                {{ request.value }}
              </router-link>
            </template>

            <template
              slot="subject"
              slot-scope="request"
            >
              {{ (request.value || '') | truncate(80) }}
            </template>

            <template
              slot="status"
              slot-scope="request"
            >
              <span
                class="badge text-white"
                :class="{ 
                  'badge-danger': request.value == 'Nouveau', 
                  'badge-dark': request.value == 'En cours au Service Client', 
                  'badge-success': request.value == 'Resolu', 
                  'badge-warning': request.value == 'En cours au Service TLS' 
                }"
              >
                {{ request.value }}
              </span>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const name = "List";

const fields = [
	{
		key: "id",
		label: "ID",
		sortable: true
	},
	{
		key: "subject",
		label: "Sujet",
		sortable: true,
		class: "font-weight-bold"
	},
	{
		key: "status",
		label: "Status",
		sortable: false
	},
	{
		key: "created_at",
		label: "Date de création",
		sortable: true,
		class: "text-right"
	}
];

const data = function () {
	return {
		filter: null,
		fields: [...fields]
	};
};

export default {
	name,
	props: {
		requests: {
			type: Array,
			required: true
		}
	},
	data,
}; 
</script>
